import React from 'react'
import Layout from './Layout';
import { TestimonyWall } from '../../components/User/Testimony'

export const TestimonyPage = () => <Layout><TestimonyWall></TestimonyWall></Layout> 
